import Badge from "@/components/UI/Badge/Badge";
import Card, { CardProps } from "@/components/UI/Card/Card";
import classNames from "classnames";

const fakeSummary = "An image or layout changed on the page.";

interface SummaryCardProps extends CardProps {
  historyItem?: any;
  page?: any;
  section?: any;
}

("No summary data available for this check at the moment, please check back later.");

const SummaryCard = ({ className, historyItem, page, section, ...props }: SummaryCardProps) => {
  if (!historyItem.englishSummary || historyItem.englishSummary === fakeSummary) {
    return <></>;
  }

  return (
    <Card
      className={classNames("flex w-full flex-1 gap-1 border-vpBlue-300 p-5", className)}
      color="primary200"
      rounded="medium"
      shadow="none"
      {...props}
    >
      <div className="space-x-2">
        <Badge
          css={{
            root: "bg-vpBlue-500 border-vpBlue-500 font-bold text-white text-md px-[10px] py-[3px] tracking-tight",
          }}
          rounded
          startNode={
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 27 27" fill="none">
              <path
                d="M23.6135 13.3836C16.6291 15.0621 15.3996 16.4215 13.8851 24.1523C12.3689 16.4197 11.1411 15.0603 4.15674 13.3836C11.1393 11.707 12.3689 10.3476 13.8833 2.61499C15.3996 10.3476 16.6273 11.707 23.6117 13.3836H23.6135Z"
                fill="white"
              />
              <path
                d="M10.6541 6.38402C8.33469 6.97149 7.92638 7.44727 7.42347 10.153C6.91996 7.44664 6.51224 6.97086 4.19287 6.38402C6.51164 5.79718 6.91996 5.3214 7.42287 2.61499C7.92638 5.3214 8.33409 5.79718 10.6535 6.38402H10.6541Z"
                fill="white"
              />
            </svg>
          }
          size="medium"
          variant="solid"
        >
          Summary
        </Badge>
        <span className="space-x-1">
          {false && historyItem.englishSummary && historyItem.englishSummary !== fakeSummary && (
            <span className="align-text-bottom font-bold">{section?.ChangeDetectionSummaryTitle}</span>
          )}
          <span className="align-text-bottom">
            {historyItem.englishSummary ? historyItem.englishSummary : section?.ChangeDetectionSummaryEmptyBody}
          </span>
        </span>
      </div>
    </Card>
  );
};

export default SummaryCard;
